import React from "react";
import { Droppable, Draggable } from "@hello-pangea/dnd";
import Block from "./Block";

export default function BuilderCanvas({ sections, preview, onAddSection, onEdit }) {
  return (
    <main className="flex-1 overflow-auto p-6">
      <div className="flex gap-2 mb-6">
        <button onClick={() => onAddSection("single")} className="btn">1 Coluna</button>
        <button onClick={() => onAddSection("two")} className="btn">2 Colunas</button>
        <button onClick={() => onAddSection("three")} className="btn">3 Colunas</button>
      </div>

      <div
        className={`mx-auto transition-all
          ${preview==="desktop" && "max-w-7xl"}
          ${preview==="tablet" && "max-w-3xl"}
          ${preview==="mobile" && "max-w-md"}
        `}
      >
        {sections.map((section) => (
          <div key={section.id} className="mb-10 bg-white rounded-xl p-4 shadow">
            <div className={`grid gap-4 grid-cols-${Object.keys(section.columns).length}`}>
              {Object.entries(section.columns).map(([colKey, blocks]) => (
                <Droppable
                  key={colKey}
                  droppableId={`section:${section.id}:${colKey}`}
                >
                  {(p) => (
                    <div
                      ref={p.innerRef}
                      {...p.droppableProps}
                      className="min-h-[120px] bg-gray-50 rounded-lg p-3 border border-dashed"
                    >
                      {blocks.map((block, index) => (
                        <Draggable
                          key={block.id}
                          draggableId={block.id}
                          index={index}
                        >
                          {(p) => (
                            <div
                              ref={p.innerRef}
                              {...p.draggableProps}
                              {...p.dragHandleProps}
                              className="mb-3"
                            >
                              <Block
                                title={(block.type || "Componente").toUpperCase()}
                                description="Clique para editar"
                                onEdit={() => onEdit(block)}
                              />
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {p.placeholder}
                    </div>
                  )}
                </Droppable>
              ))}
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}
